import React from 'react';
import { createPortal } from 'react-dom';

export default function ConfirmDialog({ title, message, onConfirm, onCancel, confirmLabel = 'Confirmar', danger = false }) {
  return createPortal(
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal" style={{ maxWidth: 380 }} onClick={e => e.stopPropagation()}>
        <h3 className="modal-title">{title}</h3>
        {message && <p style={{ color: 'var(--text-dim)', fontSize: 14, marginBottom: 20 }}>{message}</p>}
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button type="button" className="btn btn-ghost" onClick={e => { e.currentTarget.blur(); onCancel(); }}>Cancelar</button>
          <button
            type="button"
            className={`btn ${danger ? 'btn-danger' : 'btn-primary'}`}
            onClick={e => { e.currentTarget.blur(); onConfirm(); }}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
